export default {
    state: {
        menuTop: 0, // 右击菜单数据
        menuLeft: 0,
        menuShow: false,
    },
    mutations: {
        showContextMenu(state, { top, left }) {
            state.menuShow = true
            state.menuTop = top - 125
            state.menuLeft = left
            // console.log(state)
        },

        hideContextMenu(state) {
            state.menuShow = false
            // console.log(state)
        },
        hoverMenu(state, { top }) {
            state.menuTop = top - 125
        },

    },
}


// WEBPACK FOOTER //
// ./src/store/contextmenu.js